//正整数验证
let validatorIntNum = function(rule, value, callback) {
  if (value !== "" && value !== undefined) {
    if (!/^[0-9]*$/.test(value)) {
      callback(new Error("请填写正整数"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
export { validatorIntNum };
export default {
  validatorIntNum
};
